import { ChangeDetectorRef, Component } from '@angular/core';
import { DrawerService } from '../../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../../core/constants/drawer-ids.constant';
import {
  CaseBehaviour,
  ManageStudentDrawerParams,
} from '../../../insights.interface';
import { Subject, takeUntil } from 'rxjs';
import { SvgIconComponent } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NoDataComponent } from '../../../../../pages/content/no-data/no-data.component';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { DataSheetComponent } from './data-sheet/data-sheet.component';
import { InsightMode } from '../../../insights.enums';
import { ManageDataDrawerParams } from '../../insights-data/insights-data.interface';

@Component({
  selector: 'app-add-data',
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    NzTabsModule,
    NzFormModule,
    NzButtonModule,
    NoDataComponent,
    NzSelectModule,
    FormsModule,
    DataSheetComponent,
  ],
  templateUrl: './add-data.component.html',
  styleUrl: './add-data.component.scss',
})
export class AddDataComponent {
  private readonly destroy$ = new Subject<void>();
  selectedTabIndex = 0;
  caseParams: ManageStudentDrawerParams = {} as ManageStudentDrawerParams;
  disableState = false;
  isDataSheet = false;
  selectedBehavior: CaseBehaviour | null = null;
  selectedBehaviorId: number | null = null;
  dataSheetParams: ManageDataDrawerParams | null = null;
  caseBehaviors: CaseBehaviour[] = [];
  constructor(
    private readonly drawerService: DrawerService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.setupDrawerSubscription();
  }

  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<ManageStudentDrawerParams>(DRAWER_IDS.ADD_DATA)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.caseParams = params;
          this.caseBehaviors = params.case?.caseBehaviors || [];
          this.caseBehaviors = (params.case?.caseBehaviors || []).filter(
            behavior => !behavior.draft && behavior.statusId === 1
          );
          this.caseBehaviors = this.caseBehaviors.map(behavior => ({
            ...behavior,
            name: `${behavior.behaviorCategoryName} - ${behavior.behaviorCategoryTypes.map(type => type.behaviorTypeName).join(', ')}`,
          }));
        }
      });
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
    this.cdr.detectChanges();
  }

  onBehaviorChange(event: number): void {
    this.selectedBehavior =
      this.caseBehaviors.find(b => b.id === event) || null;
    this.selectedBehaviorId = event;
    if (this.selectedBehavior) {
      this.dataSheetParams = {
        case: this.caseParams.case,
        behavior: this.selectedBehavior,
        mode: InsightMode.VIEW,
        orgId: this.caseParams?.case?.student.organizationId,
        caseBehaviorId: this.selectedBehavior.id,
      };
      this.isDataSheet = true;
    }
  }
  onCancel(): void {
    this.drawerService.closeDrawer(DRAWER_IDS.ADD_DATA);
  }

  handleDisable(state: boolean) {
    this.disableState = state;
  }
}
